<script setup lang="ts">
import NavigationItem from "@/components/NavigationItem/NavigationItem.vue";
import NavigationMobile from "@/components/NavigationMobile/NavigationMobile.vue";

</script>

<template>
    <header class="sub-banner">
        <nav
            class="navbar navbar-dark dark-bar"
        >
            <div
                id="header"
                class="container"
            >
                <a class="navbar-brand navbar-header">
                    <span class="visually-hidden">
                        Annuity Ready
                    </span>
                </a>
                <ul class="mobile navbar-nav ms-auto mb-2 mb-lg-0 d-flex flex-row justify-content-between">
                    <NavigationItem />
                </ul>
                <div class="desktop d-flex">
                    <NavigationMobile />
                </div>
            </div>
        </nav>
    </header>
</template>

<style>
@media only screen and (max-width: 992px) {
  .mobile {
    display: none !important;
  }
}

@media only screen and (min-width: 993px) {
  .desktop {
    display: none !important;
  }
}
</style>
